import { useEffect } from "react";
import { AppRouter } from "./router";
import { useAuthStore } from "./stores/authStore";

function App() {
  const { initializeAuth } = useAuthStore();

  useEffect(() => {
    initializeAuth();
  }, [initializeAuth]);

  return <AppRouter />;
}

export default App;
